import { useMotionValue, useScroll, useTransform } from 'framer-motion';
import { ReactNode, useEffect } from 'react';
import { StickyTopBannerContent } from './_sticky_top_banner_content.component';

const LEAP_TRIGGER = 180;
const SCROLL_THRESHOLD = [LEAP_TRIGGER, LEAP_TRIGGER + 40];

interface Props {
	children: ReactNode;
}

export function StickyTopBannerLeapScrollVariant({ children }: Props): JSX.Element {
	const { scrollY } = useScroll();
	const pixelsScrolled = useMotionValue(0);
	const y = useTransform(pixelsScrolled, SCROLL_THRESHOLD, [-40, 0]);

	useEffect(() => {
		return scrollY.onChange((latest) => {
			if (latest < 0) return;

			pixelsScrolled.set(latest);
		});
	}, [pixelsScrolled, scrollY]);

	return <StickyTopBannerContent style={{ y }}>{children}</StickyTopBannerContent>;
}
